module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tbody', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150px"
    }
  }, [_c('div', {
    staticClass: "ui checkbox",
    attrs: {
      "width": "300px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timezoneAdjustToDST),
      expression: "timezoneAdjustToDST"
    }],
    attrs: {
      "type": "checkbox",
      "name": "timezoneAdjustToDST"
    },
    domProps: {
      "checked": Array.isArray(_vm.timezoneAdjustToDST) ? _vm._i(_vm.timezoneAdjustToDST, null) > -1 : (_vm.timezoneAdjustToDST)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.timezoneAdjustToDST,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.timezoneAdjustToDST = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.timezoneAdjustToDST = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.timezoneAdjustToDST = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Adjust to Daylight Saving Time")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "100px"
    }
  }, [_c('div', {
    staticClass: "dailydigesttime ui selection dropdown"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "digestTime"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "default text"
  }, [_vm._v("Daily Digest Time")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "0"
    }
  }, [_vm._v("12am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "1"
    }
  }, [_vm._v("1am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "2"
    }
  }, [_vm._v("2am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "3"
    }
  }, [_vm._v("3am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "4"
    }
  }, [_vm._v("4am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "5"
    }
  }, [_vm._v("5am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "6"
    }
  }, [_vm._v("6am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "7"
    }
  }, [_vm._v("7am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "8"
    }
  }, [_vm._v("8am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "9"
    }
  }, [_vm._v("9am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "10"
    }
  }, [_vm._v("10am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "11"
    }
  }, [_vm._v("11am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "12"
    }
  }, [_vm._v("12pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "13"
    }
  }, [_vm._v("1pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "14"
    }
  }, [_vm._v("2pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "15"
    }
  }, [_vm._v("3pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "16"
    }
  }, [_vm._v("4pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "17"
    }
  }, [_vm._v("5pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "18"
    }
  }, [_vm._v("6pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "19"
    }
  }, [_vm._v("7pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "20"
    }
  }, [_vm._v("8pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "21"
    }
  }, [_vm._v("9pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "22"
    }
  }, [_vm._v("10pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "23"
    }
  }, [_vm._v("11pm")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "300px"
    }
  }, [_c('div', {
    staticClass: "timezone ui selection dropdown"
  }, [_c('input', {
    attrs: {
      "type": "hidden"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "default text"
  }, [_vm._v("Timezone")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-12"
    }
  }, [_vm._v("UTC-12 (Baker Island)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-11"
    }
  }, [_vm._v("UTC-11 (Niue)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-10"
    }
  }, [_vm._v("UTC-10 (Honolulu, Tahiti)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-9"
    }
  }, [_vm._v("UTC-09 (Alaska)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-8"
    }
  }, [_vm._v("UTC-08 (Los Angeles, Seattle, Vancouver)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-7"
    }
  }, [_vm._v("UTC-07 (Denver, Edmonton, Tijuana)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-6"
    }
  }, [_vm._v("UTC-06 (Austin, Chicago, Mexico City, Milwaukee)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-5"
    }
  }, [_vm._v("UTC-05 (Lima, New York, Miami, Montreal)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-4"
    }
  }, [_vm._v("UTC-04 (Caracas, Halifax)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-3"
    }
  }, [_vm._v("UTC-03 (Buenos Aires, Montevideo)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-2"
    }
  }, [_vm._v("UTC-02 (Rio de Janeiro, São Paulo)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-1"
    }
  }, [_vm._v("UTC-01")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "0"
    }
  }, [_vm._v("UTC+00 (London, Lisbon, Reykjavik)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "1"
    }
  }, [_vm._v("UTC+01 (Amsterdam, Berlin, Oslo)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "2"
    }
  }, [_vm._v("UTC+02 (Athens, Cairo, Helsinki, Johannesburg)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "3"
    }
  }, [_vm._v("UTC+03 (Istanbul, Moscow, Madagascar)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "4"
    }
  }, [_vm._v("UTC+04 (Dubai, Tbilisi)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "5"
    }
  }, [_vm._v("UTC+05 (Lahore, Yekaterinburg)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "6"
    }
  }, [_vm._v("UTC+06 (Almaty, Kathmandu)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "7"
    }
  }, [_vm._v("UTC+07 (Bangkok, Jakarta)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "8"
    }
  }, [_vm._v("UTC+08 (Beijing, Hong Kong, Kuala Lumpur, Perth)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "9"
    }
  }, [_vm._v("UTC+09 (Seoul, Tokyo)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "10"
    }
  }, [_vm._v("UTC+10 (Vladivostok)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "11"
    }
  }, [_vm._v("UTC+11 (Melbourne, Sydney)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "12"
    }
  }, [_vm._v("UTC+12 (Auckland)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0fa6780a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/DailyDigestTiming.vue
// module id = 725
// module chunks = 2